import { render, staticRenderFns } from "./DocumentChooser.vue?vue&type=template&id=581f9b57&"
import script from "./DocumentChooser.vue?vue&type=script&lang=ts&"
export * from "./DocumentChooser.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentChooser.vue?vue&type=style&index=0&id=581f9b57&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports